import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';

export default function ReorderControls({
    disabled = false,
    canMoveUp = true,
    canMoveDown = true,
    onMoveUp,
    onMoveDown,
    onMoveTop,
    onMoveBottom,
}) {
    const disableUp = disabled || !canMoveUp;
    const disableDown = disabled || !canMoveDown;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
            <Tooltip title="Move to top">
                <span>
                    <IconButton
                        size="small"
                        onClick={onMoveTop}
                        disabled={disableUp}
                        aria-label="Move to top"
                    >
                        <VerticalAlignTopIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title="Move up">
                <span>
                    <IconButton
                        size="small"
                        onClick={onMoveUp}
                        disabled={disableUp}
                        aria-label="Move up"
                    >
                        <ArrowUpwardIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title="Move down">
                <span>
                    <IconButton
                        size="small"
                        onClick={onMoveDown}
                        disabled={disableDown}
                        aria-label="Move down"
                    >
                        <ArrowDownwardIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title="Move to bottom">
                <span>
                    <IconButton
                        size="small"
                        onClick={onMoveBottom}
                        disabled={disableDown}
                        aria-label="Move to bottom"
                    >
                        <VerticalAlignBottomIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
        </Box>
    );
}
